import {Injectable, inject} from '@angular/core';
import {InsurerService} from '../../services/domain/reference-data/insurer/insurer.service';
import {BackgroundTaskService} from '../../services/infrastructure/page/error/background-task/background-task.service';

@Injectable({
  providedIn: 'root',
})
export class InsurersResolver {

  private insurerService = inject(InsurerService);

  private readonly backgroundTaskService = inject(BackgroundTaskService);

  resolve(): void {
    this.backgroundTaskService.runInBackground(this.insurerService.getAllInsurers(true));
  }

}
